import { render, staticRenderFns } from "./Svgs.vue?vue&type=template&id=76574244&scoped=true"
import script from "./Svgs.vue?vue&type=script&lang=js"
export * from "./Svgs.vue?vue&type=script&lang=js"
import style0 from "./Svgs.vue?vue&type=style&index=0&id=76574244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76574244",
  null
  
)

export default component.exports